import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import logo from '../assets/images/utrhlogo.png';

const navLinks = [
  { to: 'about', label: 'About', isScroll: true },
  { to: 'vision', label: 'Vision', isScroll: true },
  { to: 'science', label: 'Science', isScroll: true },
  { to: 'pipeline', label: 'Pipeline', isScroll: true },
  { to: 'team', label: 'Team', isScroll: true },
  { to: 'contact', label: 'Contact', isScroll: true },
  { to: '/news', label: 'News', isScroll: false },
  { to: '/publications', label: 'Publications', isScroll: false },
];

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (to: string, isScroll: boolean) => {
    if (isScroll) {
      if (location.pathname !== '/') {
        navigate('/', { state: { scrollTo: to } });
        setIsOpen(false);
      } else {
        const section = document.getElementById(to);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
          setIsOpen(false);
        }
      }
    }
  };

  useEffect(() => {
    if (location.pathname === '/' && location.hash) {
      const sectionId = location.hash.replace('#', '');
      const element = document.getElementById(sectionId);
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);

  return (
    <div className="sticky top-0 z-40 bg-white/90 backdrop-blur-md shadow border-b border-blue-100">
      <nav className="container mx-auto px-6 py-3 flex items-center justify-between">
        <Link to="/">
          <img src={logo} alt="UTR Logo" className="h-12 w-auto" />
        </Link>

        <ul className="hidden md:flex space-x-8">
          {navLinks.map(({ to, label, isScroll }) => (
            <li key={to} className="cursor-pointer font-medium text-gray-700 hover:text-blue-600">
              {isScroll ? (
                <span onClick={() => handleNavClick(to, isScroll)}>{label}</span>
              ) : (
                <Link to={to}>{label}</Link>
              )}
            </li>
          ))}
        </ul>

        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden p-2 rounded focus:outline-none focus:ring-2"
        >
          {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden bg-white shadow px-6 py-4"
          >
            <ul className="space-y-4">
              {navLinks.map(({ to, label, isScroll }) => (
                <li key={to} className="font-medium text-gray-700 hover:text-blue-600">
                  {isScroll ? (
                    <span onClick={() => handleNavClick(to, isScroll)}>{label}</span>
                  ) : (
                    <Link to={to} onClick={() => setIsOpen(false)}>{label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Navbar;
